import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../Global.css";
import AV_Ethics from "../Resources/AV_Ethics.pdf";
import Algo_Bias from "../Resources/Algo_Bias.pdf";
import Deepfakes from "../Resources/Deepfakes.pdf";
import Betting_Ads from "../Resources/Group 1 Capstone.pdf";
import Violence_Content from "../Resources/Violence_Content.pdf";

function Writing() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="project">
      <div className="project-header">
        <div className="project-header-split-wrapper">
          {windowWidth > 767 ? (
            <>
              <h1 className="project-header-left">My Writing!</h1>
              <Link to="/" className="project-header-right">Home</Link>
            </>
          ) : (
            <>
              <Link to="/" className="project-header-right">Home</Link>
              <h1 className="project-header-left">My Writing!</h1>
            </>
          )}
        </div>
        <p>
          This section highlights some of my writing at the intersection of computer science 
          and my love of the liberal arts, exploring how technology shapes public policy, ethics, 
          and society in the digital age. Each title links to the full PDF.
        </p>
      </div>

      <div className="writing-grid" style={{
        display: "flex",
        flexDirection: "column",
        gap: "2rem",
        maxWidth: "800px",
        margin: "2rem auto 0 auto"
      }}>
        <div style={{ background: "#444", color: "#c4c4c4", padding: "1.5rem", borderRadius: "8px" }}>
          <h3>
            <a href={Deepfakes} target="_blank" rel="noopener noreferrer" style={{ color: "#c4c4c4" }}>
              Deepfakes and Democracy (Policy White Paper)
            </a>
          </h3>
          <p>
            Analyzes how AI-generated political deepfakes threaten voter trust and democratic participation,
            supporting a three-tier solution: federal labeling laws, platform liability reforms, and mandatory media literacy in schools.
          </p>
        </div>

        <div style={{ background: "#444", color: "#c4c4c4", padding: "1.5rem", borderRadius: "8px" }}>
          <h3>
            <a href={Algo_Bias} target="_blank" rel="noopener noreferrer" style={{ color: "#c4c4c4" }}>
              Algorithmic Bias in Healthcare
            </a>
          </h3>
          <p>
            Explores how a widely used healthcare algorithm disadvantaged Black patients by using costs as a proxy for health. 
            Proposes independent audits, regulatory mandates, and financial penalties to enforce fairness in critical systems.
          </p>
        </div>

        <div style={{ background: "#444", color: "#c4c4c4", padding: "1.5rem", borderRadius: "8px" }}>
          <h3>
            <a href={Betting_Ads} target="_blank" rel="noopener noreferrer" style={{ color: "#c4c4c4" }}>
              Regulating Gambling Ads (Group Capstone)
            </a>
          </h3>
          <p>
            A 50-page policy capstone recommending federal rules on gambling ads that target youth, 
            including restrictions on celebrity endorsements, strategic ad placements, and bonus transparency.
          </p>
          <p>
            <b>My role:</b> Group facilitator & PM of 8 person team — kept our 5-week timeline on track, coordinated individual check-ins, 
            led editing and practice sessions to prepare for our two-hour defense before three professors.
          </p>
        </div>

        <div style={{ background: "#444", color: "#c4c4c4", padding: "1.5rem", borderRadius: "8px" }}>
          <h3>
            <a href={AV_Ethics} target="_blank" rel="noopener noreferrer" style={{ color: "#c4c4c4" }}>
              Autonomous Vehicle Ethics
            </a>
          </h3>
          <p>
            Examines how self-driving car decision-making should prioritize pedestrian safety over consumer convenience, 
            drawing on Kantian ethics and consequentialist reasoning to argue for strong public safety regulation.
          </p>
        </div>

        <div style={{ background: "#444", color: "#c4c4c4", padding: "1.5rem", borderRadius: "8px" }}>
          <h3>
            <a href={Violence_Content} target="_blank" rel="noopener noreferrer" style={{ color: "#c4c4c4" }}>
              Insensitivity Toward Violence in Media (Exploratory Essay)
            </a>
          </h3>
          <p>
            Reflects on how sensationalized violence in true crime shows, news, and even school projects can retraumatize victims 
            and normalize harm — calling for more ethics-focused content standards and policy safeguards in the digital age.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Writing;